import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Tabs } from 'antd'
import { FaBowlRice, FaChair, FaSuitcase, FaSuitcaseRolling } from "react-icons/fa6";
import { BiSolidBowlHot } from 'react-icons/bi';
import { MdAirlineSeatReclineNormal } from 'react-icons/md';
import AirplaneSeat from './AirplaneSeat';

const { TabPane } = Tabs;

const AddonsFlight = ({
    selectedBaggages,
    addBaggage,
    removeBaggage,
    totalSelectedTravellers,
    addMeal,
    removeMeal,
    selectedMeals,
    selectedMealsReturn,
    addMealReturn,
    removeMealReturn,
    meelBaggegasData,
    errorMeelBaggegas,
    selectedBaggagesReturn,
    addBaggageReturn,
    removeBaggageReturn,
    skipAddonAndPayNow,
    getTotalSelectedBaggages,
    getTotalSelectedBaggagesReturn,
    rowsByFlight,
    setRowsByFlight,
    legends,
    setLegends,
    selectedSeats,
    handleSeatClick,
    rowsByFlightReturn,
    setRowsByFlightReturn,
    legendsReturn,
    setLegendsReturn,
    selectedSeatsReturn,
    setSelectedSeatsReturn,
    setTotalPriceReturn,
    handleSeatClickReturn,
    setSelectedSeats,
    setTotalPrice,
    setMealTotalAmount,
    setSelectedMeals,
    setSelectedBaggages,
    setTotalAmount,
    setMealTotalAmountReturn,
    setSelectedMealsReturn,
    setSelectedBaggagesReturn,
    setTotalAmountReturn
}) => {

    useEffect(() => {
        if (
            meelBaggegasData &&
            meelBaggegasData.Flight &&
            meelBaggegasData.Flight.seatDynamic
        ) {
            const flights = meelBaggegasData.Flight.seatDynamic || {};
            const flightsReturn = meelBaggegasData.Return?.seatDynamic || {};

            const rowsMap = {};
            const legendsMap = {};
            Object.entries(flights).forEach(([flightKey, flight]) => {
                rowsMap[flightKey] = flight.Rows.filter(
                    (row) => row.RowNumber !== "0"
                );
                legendsMap[flightKey] = flight;
            });

            setRowsByFlight(rowsMap);
            setLegends(legendsMap);

            const rowsMapReturn = {};
            const legendsMapReturn = {};
            Object.entries(flightsReturn).forEach(([flightKey, flight]) => {
                rowsMapReturn[flightKey] = flight.Rows.filter(
                    (row) => row.RowNumber !== "0"
                );
                legendsMapReturn[flightKey] = flight;
            });

            setRowsByFlightReturn(rowsMapReturn);
            setLegendsReturn(legendsMapReturn);

            const initSeats = {};
            const initPrice = {};
            Object.keys(flights).forEach((key) => {
                initSeats[key] = [];
                initPrice[key] = 0;
            });
            setSelectedSeatsReturn(initSeats);
            setTotalPriceReturn(initPrice);

            const initSeatsReturn = {};
            const initPriceReturn = {};
            Object.keys(flightsReturn).forEach((key) => {
                initSeatsReturn[key] = [];
                initPriceReturn[key] = 0;
            });
            setSelectedSeatsReturn(initSeatsReturn);
            setTotalPriceReturn(initPriceReturn);
        }
    }, [meelBaggegasData]);

    const [activeTab, setActiveTab] = useState("1");
    const [activeTabReturn, setActiveTabReturn] = useState("1");

    const skipSeats = () => {
        setActiveTab("2");
        setSelectedSeats({});
        setTotalPrice({});
    };

    const skipSeatsRetrun = () => {
        setActiveTabReturn("2");
        setSelectedSeatsReturn({});
        setTotalPriceReturn({});
    };


    const skipMeals = () => {
        setActiveTab("3");
        setSelectedMeals({});
        setMealTotalAmount(0);
    };

    const skipMealsReturn = () => {
        setActiveTabReturn("3");
        setSelectedMealsReturn({});
        setMealTotalAmountReturn(0);
    };

    const skipBaggage = () => {
        setSelectedBaggages({})
        setTotalAmount(0)
    };

    const skipBaggageReturn = () => {
        setSelectedBaggagesReturn({})
        setTotalAmountReturn(0)
    };



    return (
        <>
            {errorMeelBaggegas ?

                <Card className='mt-3'>
                    <p>No Baggage and Meal Available.</p>
                    <p>Please click the Continue button to proceed with the payment.</p>
                </Card>
                :
                <>
                    {(Object.keys(meelBaggegasData?.Flight?.mealsDynamic || {}).length > 0 ||
                        Object.keys(meelBaggegasData?.Flight?.baggageDynamic || {}).length > 0) ||
                        Object.keys(meelBaggegasData?.Flight?.seatDynamic || {}).length > 0 ? (
                        <div className={`card mt-2 flights-seat mb-md-3 mb-2`}>
                            <div className="bg-white rounded-3 pb-3">
                                <Tabs
                                    className='px-3'
                                    activeKey={activeTab}
                                    onChange={setActiveTab}
                                    tabBarExtraContent={
                                        <button
                                            style={{ background: "transparent", border: "none" }}
                                            onClick={skipAddonAndPayNow}
                                            className="btn btn-light text-danger"
                                        >
                                            <b>Skip addons</b>
                                        </button>
                                    }
                                >
                                    {Object.keys(meelBaggegasData?.Flight?.seatDynamic || {}).length > 0 && (
                                        <TabPane
                                            tab={
                                                <h4 className="mb-1">
                                                    <MdAirlineSeatReclineNormal className="AddonsIcon" /> Seat
                                                </h4>
                                            }
                                            key="1"
                                            className="mb-0"
                                        >

                                            <AirplaneSeat
                                                totalSelectedTravellers={totalSelectedTravellers}
                                                rowsByFlight={rowsByFlight}
                                                legends={legends}
                                                selectedSeats={selectedSeats}
                                                onClick={handleSeatClick}
                                                skipSeats={skipSeats}
                                            />
                                        </TabPane>
                                    )}

                                    {Object.keys(meelBaggegasData?.Flight?.mealsDynamic || {}).length > 0 && (
                                        <TabPane
                                            tab={<h4 className="mb-1">
                                                <FaBowlRice className="AddonsIcon" /> Meals
                                            </h4>
                                            }
                                            key="2"
                                            className='mb-0'
                                        >
                                            <div className="bg-white rounded-3">
                                                <Tabs
                                                    defaultActiveKey="0"
                                                    className="meal-tabs"
                                                    type="card"
                                                    tabBarExtraContent={
                                                        <button
                                                            style={{ background: "transparent", border: "none" }}
                                                            onClick={skipMeals}
                                                            className="btn btn-light text-danger"
                                                        >
                                                            <b>Skip Meals</b>
                                                        </button>
                                                    }
                                                >
                                                    {meelBaggegasData?.Flight?.mealsDynamic &&
                                                        Object.entries(meelBaggegasData.Flight.mealsDynamic).map(([route, meals], flightIndex) => {
                                                            // const isSingleTab = Object.keys(meelBaggegasData.Flight.mealsDynamic).length === 1;
                                                            return (
                                                                <TabPane
                                                                    // tab={route.replace("-", " - ")}
                                                                    tab={
                                                                        // !isSingleTab && (
                                                                        <div className="mb-0 w-100">
                                                                            <div className="card-body p-2">
                                                                                <div className="d-flex justify-content-start">
                                                                                    <div className="d-end fl-title ps-2">
                                                                                        <div className="fw-bold">
                                                                                            {route.replace("-", " - ")}
                                                                                        </div>
                                                                                        <div className="text-sm">
                                                                                            <span className="text-danger fw-bold">
                                                                                                {selectedMeals[flightIndex]?.selectedMeals?.reduce((total, meal) => total + (meal.Quantity || 0), 0) || 0}
                                                                                            </span>{" "}
                                                                                            of {totalSelectedTravellers} Meals selected
                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        // )
                                                                    }
                                                                    key={flightIndex}
                                                                >
                                                                    {/* {isSingleTab && (
                                                                        <div className="card">
                                                                            <div className="card-body p-2">
                                                                                <div className="d-flex justify-content-start">
                                                                                    <div className="d-end fl-title ps-2">
                                                                                        <div className="text-dark fw-bold">
                                                                                            {meals[0]?.Origin} - {meals[0]?.Destination}
                                                                                        </div>
                                                                                        <div className="text-sm text-muted">
                                                                                            <span className="text-danger">
                                                                                                {selectedMeals[flightIndex]?.selectedMeals?.reduce((total, meal) => total + (meal.Quantity || 0), 0) || 0}
                                                                                            </span>{" "}
                                                                                            of {totalSelectedTravellers} Meals selected
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>)} */}
                                                                    <div
                                                                        className="overflow-auto p-2 border rounded mt-2"
                                                                        style={{ maxHeight: "260px" }}
                                                                    >
                                                                        {meals?.map((meal, mealIndex) => {
                                                                            const selectedMeal = selectedMeals[flightIndex]?.selectedMeals?.find(
                                                                                (selected) => selected.mealIndex === mealIndex
                                                                            );
                                                                            const quantity = selectedMeal?.Quantity || 0;
                                                                            const totalSelected = selectedMeals[flightIndex]?.selectedMeals?.reduce((sum, m) => sum + (m.Quantity || 1), 0) || 0;

                                                                            return (
                                                                                <div className="d-flex align-items-center justify-content-between mb-3" key={mealIndex}>
                                                                                    <div className="d-flex align-items-center">
                                                                                        <div className="bg-primary py-md-2 px-md-3 py-1 px-1 rounded lh-1">
                                                                                            <BiSolidBowlHot className="text-white fs-4" />
                                                                                        </div>
                                                                                        <div className="ms-2">
                                                                                            <h4 className="mb-0 line-height">
                                                                                                {meal?.AirlineDescription || "No Description"}
                                                                                            </h4>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="d-flex align-items-center addons_button">
                                                                                        <div className="fw-bold">₹{meal.Price}</div>
                                                                                        <Button
                                                                                            className="btn btn-danger py-0 px-md-4 rounded ms-2"
                                                                                            onClick={() => removeMeal(flightIndex, mealIndex)}
                                                                                            disabled={quantity === 0}
                                                                                        >
                                                                                            -
                                                                                        </Button>
                                                                                        <span className="mx-2">
                                                                                            {quantity}
                                                                                        </span>
                                                                                        <Button
                                                                                            className="btn btn-primary py-0 px-md-4 rounded ms-2"
                                                                                            onClick={() => addMeal(flightIndex, mealIndex, meal)}
                                                                                            disabled={totalSelected >= totalSelectedTravellers}
                                                                                        >
                                                                                            +
                                                                                        </Button>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </TabPane>
                                                            );
                                                        })}

                                                </Tabs>
                                            </div>
                                        </TabPane>
                                    )}

                                    {Object.keys(meelBaggegasData?.Flight?.baggageDynamic || {}).length > 0 && (
                                        <TabPane
                                            tab={
                                                <h4 className="mb-1">
                                                    <FaSuitcaseRolling className="AddonsIcon" /> Baggage
                                                </h4>
                                            }
                                            key="3"
                                        >
                                            {Object.keys(meelBaggegasData?.Flight?.baggageDynamic || {}).length > 0 && (
                                                <Tabs
                                                    defaultActiveKey='1'
                                                    className="meal-tabs"
                                                    type="card"
                                                    tabBarExtraContent={
                                                        <button
                                                            style={{ background: "transparent", border: "none" }}
                                                            onClick={skipBaggage}
                                                            className="btn btn-light text-danger"
                                                        >
                                                            <b>Skip Baggages</b>
                                                        </button>
                                                    }
                                                >
                                                    {Object.entries(meelBaggegasData?.Flight?.baggageDynamic).map(
                                                        ([route, baggageOptions], routeIndex) => {
                                                            const selectedForRoute = selectedBaggages[routeIndex] || [];
                                                            const totalSelectedBaggages = getTotalSelectedBaggages(routeIndex);
                                                            const isSingleTab = Object.keys(meelBaggegasData?.Flight?.baggageDynamic).length === 1;

                                                            return (
                                                                <TabPane
                                                                    tab={
                                                                        // !isSingleTab && (
                                                                        <div className="mb-0 w-100">
                                                                            <div className="card-body p-2">
                                                                                <div className="d-flex justify-content-start">
                                                                                    <div className="d-end fl-title ps-2">
                                                                                        <div className="fw-bold">
                                                                                            {route.replace("-", " - ")}
                                                                                        </div>
                                                                                        <div className="text-sm">
                                                                                            <span className="text-danger fw-bold">
                                                                                                {selectedBaggages[routeIndex]?.selectedBaggages?.reduce((total, baggage) => total + (baggage.Quantity || 0), 0) || 0}
                                                                                            </span>{" "}
                                                                                            of {totalSelectedTravellers} Baggages selected
                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        // )
                                                                    }
                                                                    key={routeIndex}
                                                                >
                                                                    {/* Header */}

                                                                    {/* {isSingleTab && (
                                                                        <div className="card">
                                                                            <div className="card-body p-2">
                                                                                <div className="d-flex justify-content-start">
                                                                                    <div className="d-end fl-title ps-2">
                                                                                        <div className="text-dark fw-bold">
                                                                                            {route.replace("-", " - ")}
                                                                                        </div>
                                                                                        <div className="text-sm text-muted">
                                                                                            <span className="text-danger">{totalSelectedBaggages}</span> of
                                                                                            <span className="text-dark"> {totalSelectedTravellers} </span> baggage selected
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>)} */}

                                                                    {/* List */}
                                                                    <div className="overflow-auto p-2 border rounded" style={{ maxHeight: "260px" }}>
                                                                        {baggageOptions.map((baggage, baggageIndex) => {
                                                                            const selectedBaggage = selectedForRoute.find(
                                                                                (item) => item.Weight === baggage.Weight && item.Price === baggage.Price
                                                                            );
                                                                            const quantity = selectedBaggage?.Quantity || 0;

                                                                            return (
                                                                                <div className="d-flex align-items-center justify-content-between mb-3" key={baggageIndex}>
                                                                                    <div className="d-flex align-items-center">
                                                                                        <div className="bg-primary py-md-2 px-md-3 py-1 px-1 rounded lh-1">
                                                                                            <FaSuitcase className="text-white fs-4" />
                                                                                        </div>
                                                                                        <div className="ms-2">
                                                                                            <h4 className="mb-0 line-height">{`${baggage.Weight} Kg`}</h4>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="d-flex align-items-center addons_button">
                                                                                        <div className="fw-bold">₹{baggage.Price}</div>
                                                                                        <Button
                                                                                            className="btn btn-danger py-0 px-md-4 rounded ms-2"
                                                                                            onClick={() => removeBaggage(routeIndex, baggage)}
                                                                                            disabled={quantity === 0}
                                                                                        >
                                                                                            -
                                                                                        </Button>
                                                                                        <span className="mx-2">{quantity}</span>
                                                                                        <Button
                                                                                            className="btn btn-primary py-0 px-md-4 rounded ms-2"
                                                                                            onClick={() => addBaggage(routeIndex, baggage, baggage.Price)}
                                                                                            disabled={totalSelectedBaggages >= totalSelectedTravellers}
                                                                                        >
                                                                                            +
                                                                                        </Button>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </TabPane>
                                                            );
                                                        }
                                                    )}
                                                </Tabs>
                                            )}
                                        </TabPane>
                                    )}



                                </Tabs>
                            </div>
                        </div>
                    ) :
                        <Card className='mt-3'>
                            <p>No Baggage and Meal Available.</p>
                            <p>Please click the Continue button to proceed with the payment.</p>
                        </Card>
                    }

                    {Object?.keys(meelBaggegasData?.Return).length !== 0 &&
                        (Object.keys(meelBaggegasData?.Return?.mealsDynamic || {}).length > 0 ||
                            Object.keys(meelBaggegasData?.Return?.baggageDynamic || {}).length > 0) && (
                            <div className={`card mt-2 flights-seat mb-md-3 mb-2`}>
                                <div className="bg-white rounded-3 pb-3">
                                    <Tabs
                                        defaultActiveKey="1"
                                        className="px-3"
                                        activeKey={activeTabReturn}
                                        onChange={setActiveTabReturn}
                                    >
                                        {Object.keys(meelBaggegasData?.Return?.seatDynamic || {}).length > 0 && (
                                            <TabPane
                                                tab={
                                                    <h4 className="mb-1">
                                                        <MdAirlineSeatReclineNormal className="AddonsIcon" /> Seat
                                                    </h4>
                                                }
                                                key="1"
                                                className="mb-0"
                                            >
                                                <AirplaneSeat
                                                    totalSelectedTravellers={totalSelectedTravellers}
                                                    rowsByFlight={rowsByFlightReturn}
                                                    legends={legendsReturn}
                                                    selectedSeats={selectedSeatsReturn}
                                                    onClick={handleSeatClickReturn}
                                                    skipSeats={skipSeatsRetrun}
                                                />
                                            </TabPane>)}

                                        {Object.keys(meelBaggegasData?.Return?.mealsDynamic || {}).length > 0 && (
                                            <TabPane
                                                tab={<h4 className="mb-1">
                                                    <FaBowlRice className="AddonsIcon" /> Meals
                                                </h4>
                                                }
                                                key="2"
                                                className='mb-0'
                                            >
                                                <div className="bg-white rounded-3">
                                                    <Tabs
                                                        defaultActiveKey="0"
                                                        className="meal-tabs"
                                                        type="card"
                                                        tabBarExtraContent={
                                                            <button
                                                                style={{ background: "transparent", border: "none" }}
                                                                onClick={skipMealsReturn}
                                                                className="btn btn-light text-danger"
                                                            >
                                                                <b>Skip Meals</b>
                                                            </button>
                                                        }
                                                    >
                                                        {meelBaggegasData?.Return?.mealsDynamic &&
                                                            Object.entries(meelBaggegasData.Return.mealsDynamic).map(([route, meals], flightIndex) => {
                                                                const isSingleTab = Object.keys(meelBaggegasData.Flight.mealsDynamic).length === 1;
                                                                return (
                                                                    <TabPane
                                                                        tab={
                                                                            !isSingleTab && (
                                                                                <div className="mb-0">
                                                                                    <div className="card-body p-2">
                                                                                        <div className="d-flex justify-content-start">
                                                                                            <div className="d-end fl-title ps-2">
                                                                                                <div className="fw-bold">
                                                                                                    {route.replace("-", " - ")}
                                                                                                </div>
                                                                                                <div className="text-sm">
                                                                                                    <span className="text-danger fw-bold">
                                                                                                        {selectedMealsReturn[flightIndex]?.selectedMealsReturn?.reduce((total, meal) => total + (meal.Quantity || 0), 0) || 0}
                                                                                                    </span>{" "}
                                                                                                    of {totalSelectedTravellers} Meals selected
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }
                                                                        key={flightIndex}
                                                                    >
                                                                        {isSingleTab && (
                                                                            <div className="card">
                                                                                <div className="card-body p-2">
                                                                                    <div className="d-flex justify-content-start">
                                                                                        <div className="d-end fl-title ps-2">
                                                                                            <div className="text-dark fw-bold">
                                                                                                {meals[0]?.Origin} - {meals[0]?.Destination}
                                                                                            </div>
                                                                                            <div className="text-sm text-muted">
                                                                                                <span className="text-danger">
                                                                                                    {selectedMealsReturn[flightIndex]?.selectedMealsReturn?.reduce((total, meal) => total + (meal.Quantity || 0), 0) || 0}
                                                                                                </span>{" "}
                                                                                                of {totalSelectedTravellers} Meals selected
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>)}
                                                                        <div
                                                                            className="overflow-auto p-2 border rounded mt-2"
                                                                            style={{ maxHeight: "260px" }}
                                                                        >
                                                                            {meals?.map((meal, mealIndex) => {
                                                                                const selectedMeal = selectedMealsReturn[flightIndex]?.selectedMealsReturn?.find(
                                                                                    (selected) => selected.mealIndex === mealIndex
                                                                                );
                                                                                const quantity = selectedMeal?.Quantity || 0;
                                                                                const totalSelected = selectedMealsReturn[flightIndex]?.selectedMealsReturn?.reduce((sum, m) => sum + (m.Quantity || 1), 0) || 0;

                                                                                return (
                                                                                    <div className="d-flex align-items-center justify-content-between mb-3" key={mealIndex}>
                                                                                        <div className="d-flex align-items-center">
                                                                                            <div className="bg-primary py-md-2 px-md-3 py-1 px-1 rounded lh-1">
                                                                                                <BiSolidBowlHot className="text-white fs-4" />
                                                                                            </div>
                                                                                            <div className="ms-2">
                                                                                                <h4 className="mb-0 line-height">
                                                                                                    {meal?.AirlineDescription || "No Description"}
                                                                                                </h4>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="d-flex align-items-center addons_button">
                                                                                            <div className="fw-bold">₹{meal.Price}</div>
                                                                                            <Button
                                                                                                className="btn btn-danger py-0 px-md-4 rounded ms-2"
                                                                                                onClick={() => removeMealReturn(flightIndex, mealIndex)}
                                                                                                disabled={quantity === 0}
                                                                                            >
                                                                                                -
                                                                                            </Button>
                                                                                            <span className="mx-2">
                                                                                                {quantity}
                                                                                            </span>
                                                                                            <Button
                                                                                                className="btn btn-primary py-0 px-md-4 rounded ms-2"
                                                                                                onClick={() => addMealReturn(flightIndex, mealIndex, meal)}
                                                                                                disabled={totalSelected >= totalSelectedTravellers}
                                                                                            >
                                                                                                +
                                                                                            </Button>

                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </TabPane>
                                                                );
                                                            })}

                                                    </Tabs>
                                                </div>
                                            </TabPane>
                                        )}

                                        {Object.keys(meelBaggegasData?.Return?.baggageDynamic || {}).length > 0 && (
                                            <TabPane
                                                tab={
                                                    <h4 className="mb-1">
                                                        <FaSuitcaseRolling className="AddonsIcon" /> Baggage
                                                        <p className='text-primary fw-bold'>(Return)</p>
                                                    </h4>
                                                }
                                                key="3"
                                            >
                                                <div className="bg-white rounded-3">
                                                    {meelBaggegasData?.Return?.baggageDynamic &&
                                                        Object.entries(meelBaggegasData?.Return?.baggageDynamic).map(([route, baggageOptions], routeIndex) => {
                                                            const selectedForRoute = selectedBaggagesReturn[routeIndex] || [];
                                                            const totalSelectedReturn = getTotalSelectedBaggagesReturn();

                                                            return (
                                                                <div key={routeIndex}>
                                                                    <div className="card">
                                                                        <div className="card-body p-2">
                                                                            <div className="d-flex justify-content-start">
                                                                                <div className="d-end fl-title ps-2">
                                                                                    <div className="text-dark fw-bold">{route.replace('-', ' - ')}</div>
                                                                                    <div className="text-sm text-muted">
                                                                                        <span className="text-danger">{totalSelectedReturn}</span> of
                                                                                        <span className="text-dark"> {totalSelectedTravellers} </span> baggage selected
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="overflow-auto p-2 border rounded" style={{ maxHeight: '260px' }}>
                                                                        {baggageOptions.map((baggage, baggageIndex) => {
                                                                            const selectedBaggagesReturn = selectedForRoute.find(
                                                                                item => item.Weight === baggage.Weight && item.Price === baggage.Price
                                                                            );
                                                                            const quantity = selectedBaggagesReturn?.Quantity || 0;

                                                                            return (
                                                                                <div className="d-flex align-items-center justify-content-between mb-3" key={baggageIndex}>
                                                                                    <div className="d-flex align-items-center">
                                                                                        <div className="bg-primary py-md-2 px-md-3 py-1 px-1 rounded lh-1">
                                                                                            <FaSuitcase className="text-white fs-4" />
                                                                                        </div>
                                                                                        <div className="ms-2">
                                                                                            <h4 className="mb-0 line-height">{`${baggage.Weight} Kg`}</h4>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="d-flex align-items-center addons_button">
                                                                                        <div className='fw-bold'>₹{baggage.Price}</div>

                                                                                        <Button
                                                                                            className="btn btn-danger py-0 px-md-4 rounded ms-2"
                                                                                            onClick={() => removeBaggageReturn(routeIndex, baggage)}
                                                                                            disabled={quantity === 0}
                                                                                        >
                                                                                            -
                                                                                        </Button>
                                                                                        <span className="mx-2">
                                                                                            {quantity}
                                                                                        </span>
                                                                                        <Button
                                                                                            className="btn btn-primary py-0 px-md-4 rounded ms-2"
                                                                                            onClick={() => addBaggageReturn(routeIndex, baggage, baggage.Price)}
                                                                                            disabled={totalSelectedReturn >= totalSelectedTravellers}
                                                                                        >
                                                                                            +
                                                                                        </Button>

                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </TabPane>
                                        )}

                                    </Tabs>
                                </div>
                            </div>
                        )}
                </>
            }
        </>

    )
}

export default AddonsFlight